import { Component } from 'react'
import ReactPlayer from 'react-player/lazy'

class VideoPlayer extends Component {
  seekTo = (amount) => {
    try {
      this.player.seekTo(amount)
    } catch (error) {}
  }

  ref = (player) => {
    this.player = player
  }

  isMTKFireTV = /AFT/.test(navigator.userAgent)

  render() {
    return (
      <ReactPlayer
        ref={this.ref}
        url={this.props.url}
        progressInterval={100}
        className='react-player'
        width='100vw'
        height='100vh'
        controls={false}
        autoPlay={true}
        playing={this.props.isPlaying}
        loop={this.props.isUniq}
        volume={0}
        muted={true}
        onEnded={this.props.onEnded}
        onError={this.props.onError}
        onDuration={(duration) => this.props.setVideoDuration(duration)}
        onProgress={(data) => this.props.onProgress?.(data)}
        config={{
          youtube: {
            playerVars: { showinfo: 0, rel: 0, fs: 0, modestbranding: 1 },
          },
          vimeo: {
            playerOptions: {
              portrait: false,
              responsive: true,
              transparent: false,
            },
          },
          dailymotion: {
            params: {
              enable_autonext: false,
              enable_info: false,
              enable_playback_controls: false,
            },
          },
          file: {
            hlsOptions: this.isMTKFireTV
              ? {
                  capLevelToPlayerSize: true,
                  startLevel: 2,
                  autoStartLoad: true,
                  abrEwmaDefaultEstimate: 500000,
                }
              : {},
            dashOptions: this.isMTKFireTV
              ? {
                  streaming: {
                    abr: {
                      autoSwitchBitrate: { video: false },
                      initialBitrate: { video: 1500 },
                    },
                  },
                }
              : {},
          },
        }}
      />
    )
  }
}

export default VideoPlayer
